/** Source: public/design-patterns.html C-1b. */
export function DefBand({ text }: { text?: string }) {
  return <div className="def-band"><div className="shell"><p className="def">{text}</p></div></div>
}

